import { useCoreServices } from '@bangle.io/context';
import { FunMissing, TypoCat } from '@bangle.io/ui-components';
import React from 'react';
import { NoticeView } from './notice-view';

/** Displays a notice indicating that the requested note could not be found, using NoticeView. */
export function NoteNotFoundView() {
  const coreServices = useCoreServices();

  const handleNewNote = () => {
    coreServices.commandDispatcher.dispatch(
      'command::ui:create-note-dialog',
      { prefillName: undefined },
      'ui',
    );
  };

  const handleViewAllNotes = () => {
    coreServices.commandDispatcher.dispatch(
      'command::ui:toggle-all-files',
      { prefillInput: undefined },
      'ui',
    );
  };

  return (
    <NoticeView
      title={t.app.noteNotFoundView.title}
      description={
        <>
          {t.app.noteNotFoundView.description}
          <br />
          <FunMissing />
        </>
      }
      illustration={
        <TypoCat pose="owl-ears" className="mx-auto h-32 w-auto" decorative />
      }
      actions={[
        {
          label: t.app.pageWsHome.newNoteButton,
          onClick: handleNewNote,
        },
        {
          label: t.app.noteNotFoundView.viewAllNotesButton,
          variant: 'outline',
          onClick: handleViewAllNotes,
        },
      ]}
    />
  );
}
